import { usePostEmployeesCheck } from '@dostavkee/contracts-console/hooks'

export const useEmployeeCheck = () => {
    const { mutateAsync, isPending, mutate } = usePostEmployeesCheck()

    return { mutateAsync, isPending, mutate }
}
